import { useMemo } from "react";
import { currencyLabels } from "@/utils/ranges.util";
import { CompanyRangeDto } from "@advanced-sales-technologies/backend-client/models/CompanyRangeDto";
import { useTranslation } from "react-i18next";

import Badge from "@/components/atoms/Badge";

type Props = { showTitle?: boolean; year?: number | null } & CompanyRangeDto;

const getRevenueBadgeColor = (from?: number | null) => {
  if (from === null || from === undefined) return "natural";

  if (from <= 1_000_000) return "primary";
  if (from <= 5_000_000) return "secondary";
  if (from <= 10_000_000) return "success";
  if (from <= 50_000_000) return "warning";
  if (from <= 100_000_000) return "error";

  return "natural";
};

const RevenueRangeBadge = ({ from, to, year, showTitle }: Props) => {
  const { t } = useTranslation();
  if (!from && !to) return null;

  const label = useMemo(() => currencyLabels(from, to), [from, to]);
  const color = useMemo(() => getRevenueBadgeColor(from), [from]);
  return (
    <Badge
      color={color}
      label={`${label} ${showTitle ? t("company.detail.revenue") : ""}${year ? ` (${year})` : ""}`}
      size={"sm"}
    />
  );
};

export default RevenueRangeBadge;
